import { render, staticRenderFns } from "./TablesLayout.vue?vue&type=template&id=72687abc&scoped=true&"
import script from "./TablesLayout.vue?vue&type=script&lang=js&"
export * from "./TablesLayout.vue?vue&type=script&lang=js&"
import style0 from "./TablesLayout.vue?vue&type=style&index=0&id=72687abc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72687abc",
  null
  
)

export default component.exports